<div [hidden]="$isDoing3DAuth | async">
  <div class="token-generation container">
    <h2 class="token-generation-title title">
      {{ 'panTokenGeneration.title' | translate }}
    </h2>
    <form [formGroup]="formGroup" class="token-generation-form form-container">
      <!-- Card Number Field -->
      <div class="form-field" [ngClass]="{'field-invalid': showPanError}">
        <label for="pan" class="form-label">
          {{ 'application.cardNumber' | translate }}
        </label>
        <input id="pan" type="text" formControlName="pan" class="form-input" appPanFormatter [useSpaces]="($panFormatting | async) ?? true" [attr.placeholder]="($placeholders | async) ? (($panFormatting | async) !== false ? '1234 5678 9123 4567' : '1234567891234567') : null"/>
      </div>

      @if ($showExtendedFields | async) {
         <!-- Expiration Date Fields -->
        <div class="form-field" [ngClass]="{'field-invalid': showExpirationError}">
          <!-- eslint-disable-next-line -->
          <label class="form-label">
            {{ 'panTokenGeneration.expDate' | translate }}
          </label>
          <div class="expiration-fields">
            <input id="expDateMonth" type="text" maxlength="2" formControlName="expDateMonth" class="form-input form-input-exp form-input-exp-month" #expDateMonthInput appAutoFocusTransition [next]="expDateYearInput" [attr.placeholder]="($placeholders | async) ? '09' : null"/>
            <span class="expiration-separator">/</span>
            <input id="expDateYear" type="text" maxlength="2" formControlName="expDateYear" class="form-input form-input-exp form-input-exp-year" #expDateYearInput appAutoFocusTransition [prev]="expDateMonthInput" [attr.placeholder]="($placeholders | async) ? '28' : null"/>
          </div>
        </div>
      }

      @if ($showNameField | async) {
        <!-- Card Owner Name Field -->
        <div class="form-field" [ngClass]="{'field-invalid': showNameError}">
          <label for="cardOwnerName" class="form-label">
            {{ 'panTokenGeneration.cardOwnerName' | translate }}
          </label>
          <input id="cardOwnerName" type="text" formControlName="cardOwnerName" class="form-input" appNameSanitizer [attr.placeholder]="($placeholders | async) ? 'John Doe' : null"/>
        </div>
      }

      <!-- Submit Button -->
      <button
        type="button"
        [disabled]="($permissiveSubmitButton | async) ? ($isProcessedOrProcessing | async) : ($isProcessedOrProcessing | async) || formGroup.invalid"
        (click)="onSubmit()"
        class="form-button"
      >
        {{ (($panTokenButtonKey | async) ?? 'panTokenGeneration.generate') | translate }}
      </button>
    </form>

    @if (($isExpressEnabled | async) && (($displayApplePay | async) || ($displayGooglePay | async))) {
      <div class="divider">{{ 'panTokenGeneration.orUseVirtualWallet' | translate }}</div>

      <div class="express-option-container">
        @if (($displayApplePay | async)) {
          <div class="apple-pay-container">
            <app-apple-pay></app-apple-pay>
          </div>
        }
  
        @if (($displayGooglePay | async)) {
          <div class="google-pay-container">
            <app-google-pay></app-google-pay>
          </div>
        }
      </div>
    }

    <!-- Unified Error Messages -->
    <div class="form-errors">
      @if (showPanError && fc.pan.missing) {
        <div class="error-message">
          {{ 'panTokenGeneration.cardNumberRequired' | translate }}
        </div>
      } @else if (showPanError && fc.pan.tooShort) {
        <div class="error-message">
          {{ 'panTokenGeneration.cardNumberTooShort' | translate }}
        </div>
      } @else if (showPanError && fc.pan.tooLong) {
        <div class="error-message">
          {{ 'panTokenGeneration.cardNumberTooLong' | translate }}
        </div>
      } @else if (showPanError && fc.pan.luhnInvalid) {
        <div class="error-message">
          {{ 'panTokenGeneration.wrongCardNumber' | translate }}
        </div>
      }
      
      @if (showExpirationError && fc.expDateMonth.missing) {
        <div class="error-message">
          {{ 'panTokenGeneration.expDateMonthRequired' | translate }}
        </div>
      } @else if (showExpirationError && fc.expDateMonth.badFormat) {
        <div class="error-message">
          {{ 'panTokenGeneration.wrongExpMonth' | translate }}
        </div>
      }
      
      @if (showExpirationError && fc.expDateYear.missing) {
        <div class="error-message">
          {{ 'panTokenGeneration.expDateYearRequired' | translate }}
        </div>
      } @else if (showExpirationError && fc.expDateYear.patternFail) {
        <div class="error-message">
          {{ 'panTokenGeneration.wrongExpYear' | translate }}
        </div>
      }
      
      @if (!(fc.expDateMonth.badFormat || fc.expDateYear.patternFail) && expirationDateInPast) {
        <div class="error-message">
          {{ 'panTokenGeneration.expInPast' | translate }}
        </div>
      }
      
      @if (showNameError && fc.cardOwnerName.missing) {
        <div class="error-message">
          {{ 'panTokenGeneration.cardOwnerNameRequired' | translate }}
        </div>
      }

      @for (error of ($tpsErrors | async); track error) {
        <div class="error-message">
          {{ 'error.somethingWentWrong' | translate }}: {{ 'ecommerceResponseCodes.' + error.responseCodeName | translate }}
        </div>
      }

      @for (error of ($ecommErrors | async); track error) {
        <div class="error-message">
          {{ error.translateKey | translate }}
        </div>
      }
    </div>
  </div>
</div>
<iframe class="hostApp-3DSecure" [hidden]="($isDoing3DAuth | async) === false" id="3DSecureFrame" width="100%" height="100%"></iframe>
